export enum PillStatus {
  ToDo,
  Blocked,
  Delayed,
  Done,
  InProgress,
}
